<script>
	import $ from 'jquery';
	import _ from 'lodash';
	import json5 from 'json5';
	import ssmlHelper from 'view/insertion/ssml-helper';

	export default {
		translationCategory: 'insertion.InsertionSSMLEditor',
		data() {
			return {
				selectTextFirst: this.$tCaption('Please select a text to apply a text attribute.'),
				selectVoiceFirst: this.$tCaption('Please select a voice.'),
				joditConfig: {
					minHeight: 280,
					events: {
						getIcon: function (name, control, clearName) {
							let code = name;
							switch (clearName) {
								case 'source':
									code = 'code';
									break;
								case 'undo':
									code = 'undo';
									break;
								case 'redo':
									code = 'redo';
									break;
							}

							return code ? `<i style="font-size:14px" class="ssml-icon fa fa-${code} fa-xs"></i>` : null;
						}
					},
					showCharsCounter: false,
					showWordsCounter: true,
					showXPathInStatusbar: false,
					beautyHTML: true,
					askBeforePasteFromWord: false,
					askBeforePasteHTML: false,
					defaultActionOnPaste: 'insert_only_text'
				},
				joditVolume: {
					tooltip: {
						enabled: true,
						showMode: 'always',
						position: 'bottom',
						format: (v) => `${v}%`
					}
				},
				joditBreak: {
					tooltip: {
						enabled: true,
						showMode: 'always',
						position: 'bottom',
						format: (v) => `${v}ms`
					}
				},
				joditNonLexicalSounds: {
					intensityLabel: {
						visible: true,
						position: 'top',
						format: (v) => `${v}`
					},
					intensityTooltip: {
						enabled: true,
						showMode: 'always',
						position: 'bottom',
						format: (v) => `${v}`
					}
				},
				joditLexicon: {
					visible: false,
					lexicons: []
				},
				joditStylizer: {
					visible: false,
					styles: []
				},
				joditCustomTNs: {
					visible: false,
					lexicons: []
				},
				joditTextPronunciationTool: {
					visible: false,
					value: null
				},
				updatedTags: {},
				editingNodeInfo: {},
				editingTag: null,
				editingAttribute: null
			};
		},
		mounted() {
			if (__DEBUG__)
				window.json5 = json5;
		},
		destroyed() {
			delete this.$savedRanges;
			delete this.$cachedSelection;
		},
		methods: {
			checkTextSelected() {
				let text = `${this.getJoditSelectedText()}`;
				if (!text.length) {
					this.$notifyError(this.selectTextFirst);
					return false;
				}
				return true;
			},
			applyEditingNodeValues() {
				let info = this.editingNodeInfo;
				let tagConfig = info?.tagConfig || {};

				if (__DEBUG__)
					console.debug('applyEditingNodeValues', { info });

				tagConfig.attributes.map(f => {
					if (info.values[f.id] != undefined) {
						if (f.json5) {
							let value = typeof(info.values[f.id]) === 'object' && json5.stringify(info.values[f.id], { quote: "'" }) || info.values[f.id];
							info.node.setAttribute(f.id, value);
						} else if (f.htmlEncode) {
							info.node.setAttribute(f.id, this.$Data.decodeHTML(info.values[f.id]));
						} else {
							info.node.setAttribute(f.id, info.values[f.id]);
						}
					} else {
						info.node.removeAttribute(f.id);
					}
				});

				if (tagConfig.afterEdit) {
					tagConfig.afterEdit(info.node, info.values);
				}
			},
			applyEditTag(opts) {
				let info = this.editingNodeInfo;
				let tagConfig = info?.tagConfig || {};
				let virtual = opts?.virtual;

				if (__DEBUG__)
					console.debug('applyEditTag', { info, opts });

				this.applyEditingNodeValues();

				let tagNode = virtual ? info.node.cloneNode() : info.node;
				
				if (info.isNew) {
					let selection = window.getSelection();
					let range = this.$savedRanges && this.$savedRanges[0] || selection && selection.getRangeAt(0);
					let editor = document.querySelector('.jodit-wysiwyg');
					if (range && editor?.contains(range.startContainer)) {
						let container = range.startContainer?.closest ? range.startContainer : range.startContainer.parentNode;
						if (container.closest) {
							let doNotSupportsSubTags = container.closest('[support-sub-tags=false]');
							if (doNotSupportsSubTags) {
								selection.selectAllChildren(doNotSupportsSubTags);
								range = selection.getRangeAt(0);
							}
						}

						if (tagConfig.supportsSubTags === false) {
							let selectedPart = virtual ? range.cloneContents() : range.extractContents();

							let node = null;
							let findNestedNode = (n) => {
								if (n.childNodes?.length) {
									[...n.childNodes].filter(cn => !['#text', 'editor-action'].includes(cn.nodeName.toLowerCase())).map(cn => {
										if (cn.nodeName.toLowerCase() !== 'span' && ssmlHelper.tagsList.includes(cn.nodeName.toLowerCase())) {
											node = cn;
										}
										findNestedNode(cn);
									});
								}
							}
							findNestedNode(selectedPart);

							if (node) {
								if (virtual) {
									node = node.cloneNode();
								}
								[...(node.childNodes || [])].map(cn => {
									tagNode.appendChild(cn);
								});

								node.appendChild(tagNode);
								ssmlHelper.clearDom(tagNode);

								if (!virtual) {
									range.insertNode(selectedPart);
								}
							} else {
								if (!tagConfig.removeContent) {
									tagNode.appendChild(selectedPart);
								}

								ssmlHelper.clearDom(tagNode);
								range.insertNode(tagNode);
							}

							if (__DEBUG__)
								console.debug('applyEditTag: insert into nested', { n: info.node, parent: node });
						} else {
							let selectedPart = virtual ? range.cloneContents() : range.extractContents();

							if (!tagConfig.removeContent) {
								tagNode.appendChild(selectedPart);
							}

							if (__DEBUG__)
								console.debug('applyEditTag: insert into range', { range, selectedPart, info });

							ssmlHelper.clearDom(tagNode);

							if (!virtual) {
								range.insertNode(tagNode);
							}
						}
					} else {
						if (__DEBUG__)
							console.debug('applyEditTag: insert into caret position', { range, info });
						ssmlHelper.clearDom(tagNode);

						if (!virtual) {
							this.editor().selection.insertNode(info.node);
						}
					}
				}

				if (virtual) {
					return tagNode;
				}

				this.editingTag = null;
				this.editingAttribute = null;

				if (__DEBUG__)
					console.debug('Node edited', info.node.outerHTML);

				this.$nextTick(() => {
					if (this.$refs.joditEditor) {
						this.$refs.joditEditor.isInnerFormatting = true;
					}
					this.ssml = ssmlHelper.clearPreformat(this.editor().value);
					if (this.$refs.joditEditor) {
						this.$refs.joditEditor.preformat();

						this.$nextTick(() => {
							this.editor().selection.setCursorAfter(info.node);
							this.$nextTick(() => {
								this.$refs.joditEditor.isInnerFormatting = false;
							})
						});
					}
				});
			},
			getNodeText(node) {
				if (!node) return '';

				let textNode = node.cloneNode(true);
				[...(textNode.querySelectorAll('editor-action') || [])].map(f => f.remove());
				let text = textNode.innerText;
				textNode.remove();
				textNode = null;

				return text;
			},
			editTag(tag, attribute, node, opts) {
				this.saveSelection();
				let selectedText = `${this.getJoditSelectedText()}`;
				let text = selectedText;
				let nodeText = this.getNodeText(node);

				if (__DEBUG__)
					console.debug('Edit tag', { tag, attribute, node });

				let tagConfig = ssmlHelper.tags[tag];
				let attributeConfig = tagConfig?.attributes?.find(f => f.id === attribute);
				
				let isNew = false;
				if (!node) {
					node = document.createElement(tag);
					isNew = true;
				} else {
					text = nodeText;
				}

				if (!node.hasAttribute(attribute) && attribute && tagConfig?.defaults) {
					node.setAttribute(attribute, tagConfig.defaults[attribute] != null ? tagConfig?.defaults[attribute] : '');
				}

				let values = {};
				tagConfig.attributes.map(f => {
					let nodeAttrId = f.id.toLowerCase();
					if (node.hasAttribute(nodeAttrId)) {
						if (f.json5) {
							values[f.id] = node.hasAttribute(nodeAttrId) ? json5.parse(node.getAttribute(nodeAttrId) || (tagConfig.defaults || {})[f.id]) : (tagConfig.defaults || {})[f.id];
						} else if (f.htmlEncode){
							values[f.id] = node.hasAttribute(nodeAttrId) ? this.$Data.decodeHTML(node.getAttribute(nodeAttrId) || (tagConfig.defaults || {})[f.id]) : (tagConfig.defaults || {})[f.id];
						} else {
							values[f.id] = node.hasAttribute(nodeAttrId) ? node.getAttribute(nodeAttrId) : (tagConfig.defaults || {})[f.id];
						}
					}
				});

				if (tagConfig.uiAttributes) {
					tagConfig.uiAttributes.map(f => {
						values[f.id] = f.default;
					});

				}

				if (tagConfig.beforeEdit) {
					tagConfig.beforeEdit(node, values);
				}

				if (opts?.attributes) {
					_.assign(values, opts?.attributes);
				}

				this.$set(this, 'editingNodeInfo', {
					node,
					tag,
					attribute,
					opts,
					isNew,
					tagConfig,
					attributeConfig,
					values,
					selectedText,
					text
				});

				this.editingTag = null;
				this.editingAttribute = null;

				if (!opts?.preventDialog) {
					this.$nextTick(() => {
						this.editingTag = tag;
						this.editingAttribute = attribute;
					});
				}
			},
			getTagButtons() {
				let btns = this.getCustomJoditButtons({ all: true });
				let items = [];
				let process = (list) => {
					list.map(f => {
						if (f.items) {
							process(f.items);
						} else {
							if (f.tag) {
								items.push(f);
							}
						}
					});
				}
				process(btns);
				return items;
			},
			getListOfUsedTags() {
				let btns = this.getCustomJoditButtons({ all: true });
				let items = [];
				let process = (list) => {
					list.map(f => {
						if (f.items) {
							process(f.items);
						} else {
							if (f.tag) {
								let name = `${f.text}:\n\tTag: ${f.tag}${f.attribute ? `\n\tAttr: ${f.attribute}` : ''}`
								if (!items.includes(name)) {
									items.push(name);
								}
							}
						}
					});
				}
				process(btns);
				return items;
			},
			tagIsSupported(tag, attribute) {
				let settings = (this.selectedVoice?.allSettings || []).find(f => f.TtsModelCode === (this.voiceTypeModel || null)) || this.selectedVoice?.settings;
				if (!settings) return true;

				if (['adthos:wbs', 'adthos:variativetext'].includes(tag)) return true;
				
				let res = settings.SupportSsml;

				if (!res) {
					let supportedOptions = (settings?.SupportedOptions || '').split(',').map(f => f?.toLowerCase()?.trim()).filter(f => f);
					res = supportedOptions.includes(tag?.toLowerCase());
				} else {
					if (settings?.SupportedTags?.length) {
						if (!attribute) {
							res = settings.SupportedTags.some(f => f.Name?.toLowerCase() === tag?.toLowerCase());
						} else {
							res = settings.SupportedTags.some(f => f.Name?.toLowerCase() === tag?.toLowerCase() && (!f.Attributes?.length || f.Attributes.map(f => f.toLowerCase()).includes(attribute)));
						}
					}
				}

				if (__DEBUG__)
					console.debug(`Supported tag ${tag}: ${res}`, { r: settings?.SupportedTags?.some(f => f.Name?.toLowerCase() === tag?.toLowerCase()) });

				return res;
			},
			filterJoditButtons(btns) {
				let checkItem = (item) => {
					return this.tagIsSupported(item.tag, item.attribute);
				}

				let result = [];

				let totalItems = 0;
				btns.map(b => {
					totalItems += b?.items?.length ? b.items.filter(f => checkItem(f)).length : (checkItem(b) ? 1 : 0);
				});

				btns.map(b => {
					if (b.items) {
						let items = b.items.filter(f => checkItem(f));
						if (items.length) {
							if (totalItems <= 5) {
								result.push(...items);
							} else {
								result.push({
									...b,
									items
								});
							}
						}
					} else {
						if (checkItem(b)) {
							result.push(b);
						}
					}
				});

				if (__DEBUG__)
					console.debug('filterJoditButtons', { result });

				return result;
			},
			getCustomJoditButtons(opts) {
				const isBaseSSML = (this.selectedVoice?.voice?.TtsProviderType || 0) === 0 || !!this.selectedVoice?.settings;
				const isElevenLabs = (this.selectedVoice?.voice?.TtsProviderType || 0) === 2 && !isBaseSSML;

				const intonationGroup = {
					name: 'intonationGroup',
					text: 'Intonation',
					icon: 'wave-square',
					groupEnd: true,
					items: [
						{
							name: 'intonation',
							group: 'intonationGroup',
							text: this.$tCaption('Intonation'),
							icon: 'wave-square',
							tag: 'prosody',
							attribute: 'contour',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('prosody', 'contour');
							}
						},
						{
							name: 'intonationLevelUp',
							group: 'intonationGroup',
							text: '20%',
							icon: 'arrow-up',
							tag: 'prosody',
							attribute: 'contour',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('prosody', 'contour', void 0, { preventDialog: true });
								let points = ssmlHelper.parseContourPoints(this.editingNodeInfo.values['contour']);
								if (points.length > 0) {
									points[0].y = points[0].y + 20 < 100 ? points[0].y + 20 : 100;
									points[1].y = points[1].y + 20 < 100 ? points[1].y + 20 : 100;
									this.editingNodeInfo.values['contour'] = ssmlHelper.calcContourPointsValue(points);
									this.applyEditTag();
								}
							}
						},
						{
							name: 'intonationLevelDown',
							group: 'intonationGroup',
							text: '20%',
							icon: 'arrow-down',
							tag: 'prosody',
							attribute: 'contour',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('prosody', 'contour', void 0, { preventDialog: true });
								let points = ssmlHelper.parseContourPoints(this.editingNodeInfo.values['contour']);
								if (points.length > 0) {
									points[0].y = points[0].y - 20 > -100 ? points[0].y - 20 : -100;
									points[1].y = points[1].y - 20 > -100 ? points[1].y - 20 : -100;
									this.editingNodeInfo.values['contour'] = ssmlHelper.calcContourPointsValue(points);
									this.applyEditTag();
								}
							}
						},
						{
							name: 'intonationToLeft',
							group: 'intonationGroup',
							text: this.$tCaption('Rotate Up'),
							icon: 'arrow-up',
							tag: 'prosody',
							attribute: 'contour',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('prosody', 'contour', void 0, { preventDialog: true });
								let points = ssmlHelper.parseContourPoints(this.editingNodeInfo.values['contour']);
								if (points.length > 0) {
									points[0].y = points[0].y - 20 > -100 ? points[0].y - 20 : -100;
									points[1].y = points[1].y + 20 < 100 ? points[1].y + 20 : 100;
									this.editingNodeInfo.values['contour'] = ssmlHelper.calcContourPointsValue(points);
									this.applyEditTag();
								}
							}
						},
						{
							name: 'intonationToRight',
							group: 'intonationGroup',
							text: this.$tCaption('Rotate Down'),
							icon: 'arrow-down',
							tag: 'prosody',
							attribute: 'contour',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('prosody', 'contour', void 0, { preventDialog: true });
								let points = ssmlHelper.parseContourPoints(this.editingNodeInfo.values['contour']);
								if (points.length > 0) {
									points[0].y = points[0].y + 20 < 100 ? points[0].y + 20 : 100;
									points[1].y = points[1].y - 20 > -100 ? points[1].y - 20 : -100;
									this.editingNodeInfo.values['contour'] = ssmlHelper.calcContourPointsValue(points);
									this.applyEditTag();
								}
							}
						},
					]
				}
				const dataButton = {
					name: 'data',
					text: this.$tCaption('Data'),
					icon: 'robot',
					prevent: true,
					tag: 'adthos:wbs',
					exec: (opts, btn, e) => {
						if (__DEBUG__)
							console.debug('Show data', { opts, btn, e });
						if (e?.control) {
							if (this.$refs.dataContextMenu)
								this.$refs.dataContextMenu.show();
							return;
						}
						let wbsParams = opts?.wbsParams;

						this.editTag('adthos:wbs', 'id', void 0, { preventDialog: wbsParams?.addImmediate });

						if (wbsParams) {
							Object.keys(wbsParams).map(key => this.$set(this.editingNodeInfo.values, key, wbsParams[key]));
						}

						if (wbsParams?.addImmediate) {
							this.applyEditTag();
						}
					}
				};

				const insertionsGroup = {
					name: 'insertionsGroup',
					text: 'Add',
					icon: 'plus',
					groupEnd: true,
					items: [
						...(!isBaseSSML ? [] : [
							{
								name: 'break_btn',
								text: this.$tCaption('Break'),
								icon: 'pause',
								tag: 'break',
								exec: () => {
									this.editTag('break', 'time');
								},
								groupEnd: true
							},
							{
								name: 'nlcs_btn',
								text: this.$tCaption('NLC Sounds'),
								icon: 'podcast',
								tag: 'adthos:audio',
								exec: () => {
									if (!this.selectedVoice) {
										this.$notifyError(this.selectVoiceFirst);
										return;
									}

									this.editTag('adthos:audio', 'id');
								}
							},
						]),
						dataButton,
						{
							name: 'variativetext',
							text: this.$tCaption('Variative text'),
							icon: 'list-ul',
							tag: 'adthos:variativetext',
							exec: () => {
								this.editTag('adthos:variativetext', 'variants');
							}
						},
					]
				}

				const readingGroup = {
					name: 'readingGroup',
					text: this.$tCaption('Reading'),
					icon: 'language',
					groupEnd: true,
					items: [
						{
							name: 'phoneme',
							text: this.$tCaption('Phoneme'),
							icon: 'language',
							tag: 'phoneme',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('phoneme', 'ph');
							}
						},
						{
							name: 'reading',
							text: this.$tCaption('Reading'),
							icon: 'book-open',
							tag: 'say-as',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('say-as', 'interpret-as');
							}
						},
						{
							name: 'emphasis',
							text: this.$tCaption('Emphasis'),
							icon: 'e',
							list: ['none', 'reduced', 'moderate', 'strong'],
							tag: 'emphasis',
							exec: (editor, btn, { control }) => {
								if (control?.name === 'emphasis') {
									return true;
								}
								if (control?.args) {
									const emphaisLevel = control?.args[0];
									if (__DEBUG__)
										console.debug('Set emphasis', emphaisLevel);

									if (!this.checkTextSelected()) return;
									this.editTag('emphasis', 'level', void 0, { preventDialog: true });
									this.editingNodeInfo.values['level'] = emphaisLevel;
									this.applyEditTag();
								}
							}
						},
						{
							name: 'lexicon',
							text: this.$tCaption('Lexicon'),
							icon: 'l',
							list: [...(this.joditLexicon?.lexicons || []).map(f => ({ text: f.Name, key: f.Oid })), { text: 'Manage', icon: 'cog', key: 'manage' }],
							tag: 'lexicon',
							exec: (editor, btn, { control }) => {
								if (__DEBUG__)
									console.debug('Lexicon', { editor, btn, control });
								if (control?.args[0] === 'manage') {
									this.joditLexicon.visible = false;
									setImmediate(() => {
										if (this._isDestroyed) return;
										this.joditLexicon.visible = true;
									});
									return true;
								}
								if (control?.args) {
									const lexicon = this.joditLexicon?.lexicons?.find(f => f.Oid === control?.args[0]);
									if (__DEBUG__)
										console.debug('Add lexicon', control?.args[0], { lexicon });
									if (lexicon?.LexiconFile?.AzureFileUrl) {
										let value = ssmlHelper.prepareSsml(`${editor.value}` || ' ', {
											...this.record,
											sender: this,
											afterProcess: (data) => {
												if (__DEBUG__)
													console.debug('Prepare ssml afterProcess', { data });
												data.voice.prepend(` <lexicon name="${lexicon.Name}" uri="${lexicon?.LexiconFile?.AzureFileUrl}"></lexicon> `);
											}
										})?.ssml;
										this.ssml = value;
										if (this.record) this.record.ssml = value;
										this.$nextTick(() => {
											if (this.$refs.joditEditor)
												this.$refs.joditEditor.calcFormat(true);
										});
									}
								}
							}
						},
						{
							name: 'customtn',
							text: this.$tCaption('Custom TN'),
							icon: 'c',
							list: [...(this.joditCustomTNs?.lexicons || []).map(f => ({ text: f.Name, key: f.Oid })), { text: 'Manage', icon: 'cog', key: 'manage' }],
							tag: 'customtn',
							exec: (editor, btn, { control }) => {
								if (__DEBUG__)
									console.debug('Custom TN', { editor, btn, control });
								if (control?.args[0] === 'manage') {
									this.joditCustomTNs.visible = false;
									setImmediate(() => {
										if (this._isDestroyed) return;
										this.joditCustomTNs.visible = true;
									});
									return true;
								}
								if (control?.args) {
									const lexicon = this.joditCustomTNs?.lexicons?.find(f => f.Oid === control?.args[0]);
									if (__DEBUG__)
										console.debug('Add Custom TN', control?.args[0], { lexicon });
									if (lexicon?.LexiconFile?.AzureFileUrl) {
										let value = ssmlHelper.prepareSsml(`${editor.value}` || ' ', {
											...this.record,
											sender: this,
											afterProcess: (data) => {
												if (__DEBUG__)
													console.debug('Prepare ssml afterProcess', { data });
												data.voice.find('mstts\\:customtn').remove();
												data.voice.prepend(` <mstts:customtn url="${lexicon?.LexiconFile?.AzureFileUrl}"></mstts:customtn> `);
												data.voice.attr('customtn', lexicon.Name);
											}
										})?.ssml;
										this.ssml = value;
										if (this.record) this.record.ssml = value;
										this.$nextTick(() => {
											if (this.$refs.joditEditor)
												this.$refs.joditEditor.calcFormat(true);
										});
									}
								}
							}
						},
						{
							name: 'stylizer',
							text: this.$tCaption('Stylizer'),
							icon: 's',
							list: [...(this.joditStylizer?.styles || []).map(f => ({ text: f.Name, key: f.Oid })), { text: 'Manage', icon: 'cog', key: 'manage' }],
							tag: 'adthos:stylizer',
							exec: (editor, btn, { control }) => {
								if (control?.args[0] === 'manage') {
									this.joditStylizer.visible = false;
									setImmediate(() => {
										if (this._isDestroyed) return;
										this.joditStylizer.visible = true;
									});
									return true;
								}
								if (!this.checkTextSelected()) return;
								if (__DEBUG__)
									console.debug('Stylizer', { editor, btn, control });
								if (control?.args) {
									const stylizer = this.joditStylizer?.styles?.find(f => f.Oid === control?.args[0]);
									if (__DEBUG__)
										console.debug('Add stylizer', control?.args[0], { stylizer });
									if (stylizer?.Oid) {
										this.editTag('adthos:stylizer', 'id', void 0, { preventDialog: true });
										this.editingNodeInfo.values['id'] = stylizer?.Oid;
										this.editingNodeInfo.values['name'] = stylizer.Name;
										this.applyEditTag();
									}
								}
							}
						},
					]
				}

				const toolsGroup = {
					name: 'toolsGroup',
					text: this.$tCaption('Tools'),
					icon: 'toolbox',
					items: [
						{
							name: 'ssmlTextPronunciation',
							text: this.$tCaption('Pronunciation tool'),
							icon: 'language',
							tag: 'text-pronunciation-tool',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.joditTextPronunciationTool.value = `${this.getJoditSelectedText()}`;
								setImmediate(() => {
									this.$refs.textPronunciationTool.show();
								});
							}
						},
						{
							name: 'ssmlSayAsTool',
							text: this.$tCaption('Speech to speech'),
							icon: 'microphone',
							tag: 'say-as-tool',
							exec: () => {
								this.saveSelection();
								this.$refs.sayAsTool.show();
							}
						},
						{
							name: 'ssmlVoiceConversionTool',
							text: this.$tCaption('Voice conversion'),
							icon: 'microphone-lines',
							tag: 'voice-conversion-tool',
							exec: () => {
								this.saveSelection();
								this.$refs.voiceConversionTool.show();
							}
						},
						{
							name: 'ssmlOverdubbingTool',
							text: this.$tCaption('Overdubbing tool'),
							icon: 'indent',
							tag: 'overdubbing-tool',
							exec: () => {
								this.saveSelection();
								this.$refs.overdubbingTool.show();
							}
						}
					]
				}

				const buttons = [
					{
						name: 'rate',
						text: this.$tCaption('Rate'),
						icon: 'forward',
						groupEnd: true,
						tag: 'prosody',
						attribute: 'rate',
						exec: () => {
							if (!this.checkTextSelected()) return;
							this.editTag('prosody', 'rate');
						}
					},
					{
						name: 'pitch',
						text: this.$tCaption('Pitch'),
						icon: 'sort',
						groupEnd: true,
						tag: 'prosody',
						attribute: 'pitch',
						exec: () => {
							if (!this.checkTextSelected()) return;
							this.editTag('prosody', 'pitch');
						}
					},
					{
						name: 'volume',
						text: this.$tCaption('Volume'),
						icon: 'volume-up',
						groupEnd: true,
						tag: 'prosody',
						attribute: 'volume',
						exec: () => {
							if (!this.checkTextSelected()) return;
							this.editTag('prosody', 'volume');
						}
					},
					intonationGroup,
					insertionsGroup,
					readingGroup,
					toolsGroup,
				];

				if (this.voiceStylesFiltered || opts?.all) {
					const voiceStylesList = this.voiceStylesFiltered?.reduce((acc, item) => _.set(acc, item.id, item.label), {});

					if (!_.isEmpty(voiceStylesList) || opts?.all) {
						readingGroup.items.push({
							name: 'style',
							text: this.$tCaption('Style'),
							icon: 'exclamation-circle',
							list: voiceStylesList,
							tag: 'mstts:express-as',
							attribute: 'style',
							exec: (editor, btn, { control }) => {
								if (control?.list) return false;
								if (control?.args) {
									if (!this.checkTextSelected()) return;
									this.editTag('mstts:express-as', 'style');
									this.editingNodeInfo.values['style'] = control?.args[0];
									this.applyEditTag();
								}
							}
						});

						readingGroup.items.push({
							name: 'styleDegree',
							text: this.$tCaption('Style degree'),
							icon: 'volume-high',
							tag: 'mstts:express-as',
							attribute: 'styledegree',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('mstts:express-as', 'styledegree');
							}
						});
					}
				}

				if (opts?.all) {
					return buttons;
				}

				if (this.templateFields?.length && this.allowKeyEditing) {
					insertionsGroup.items.push({
						name: 'templteFields',
						text: this.$tCaption('Template fields'),
						icon: 'caret-square-right',
						list: this.templateFields.reduce((acc, item) => _.set(acc, item.id, item.description), {}),
						exec: (editor, btn, { control }) => {
							if (control?.list) return false;
							if (control?.args) {
								this.editor().selection.insertHTML(`[!${control?.args[0]}]`);
							}
						}
					})
				}

				if (isElevenLabs) {
					return this.filterJoditButtons([
						...insertionsGroup.items,
						{
							name: 'ssmlTextPronunciation',
							text: this.$tCaption('Pronunciation tool'),
							icon: 'language',
							tag: 'text-pronunciation-tool',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.joditTextPronunciationTool.value = `${this.getJoditSelectedText()}`;
								setImmediate(() => {
									this.$refs.textPronunciationTool.show();
								});
							}
						},
					]);
				}

				if (!isBaseSSML) {
					return this.filterJoditButtons([
						{
							name: 'break_btn',
							text: this.$tCaption('Break'),
							icon: 'pause',
							tag: 'break',
							exec: () => {
								this.editTag('break', 'time');
							},
							groupEnd: true
						},
						{
							name: 'reading',
							text: this.$tCaption('Reading'),
							icon: 'book-open',
							tag: 'say-as',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.editTag('say-as', 'interpret-as');
							}
						},
						insertionsGroup,
						{
							name: 'ssmlTextPronunciation',
							text: this.$tCaption('Pronunciation tool'),
							icon: 'language',
							tag: 'text-pronunciation-tool',
							exec: () => {
								if (!this.checkTextSelected()) return;
								this.joditTextPronunciationTool.value = `${this.getJoditSelectedText()}`;
								setImmediate(() => {
									this.$refs.textPronunciationTool.show();
								});
							}
						},
					])
				}

				return this.filterJoditButtons(buttons);
			},
			editor() {
				return this.$refs.joditEditor && this.$refs.joditEditor.editor;
			},
			getJoditSelectedText() {
				let editor = this.editor();
				return editor ? $(`<div>${editor && editor.selection && editor.selection.html}</div>`).text() : '';
			},
			simplifySelection() {
				let editor = this.editor();
				if (__DEBUG__)
					console.debug('Simplify selection', {
						selectionHtml: editor.selection.html,
						node: editor.selection.sel.focusNode
					});
				if (editor?.selection?.sel?.focusNode && editor.selection.html)
					editor.selection.setCursorAfter(editor.selection.sel.focusNode);
			},
			saveSelection() {
				if (__DEBUG__)
					console.debug('saveSelection');
				const selection = window.getSelection();
				const savedRanges = [];
				for (let i = 0; i < selection.rangeCount; ++i) {
					savedRanges.push(selection.getRangeAt(i));
				}
				this.$savedRanges = savedRanges;
				this.$cachedSelection = this.editor?.selection?.html;
			},
			restoreSelection(simplifySelection) {
				if (this.$savedRanges?.length === 0) return;

				const selection = window.getSelection();

				let savedRanges = this.$savedRanges || [];
				selection.removeAllRanges();
				for (const range of savedRanges.filter(({startContainer: {nodeName}}) => nodeName === "TR")) {
					selection.addRange(range);
				}
				for (const range of savedRanges.filter(({startContainer: {nodeName}}) => nodeName !== "TR")) {
					selection.addRange(range);
				}
				if (simplifySelection)
					this.simplifySelection();
			},
			clearSelection() {
				let editor = this.editor();
				return editor && editor.selection.selectRange(editor.selection.createRange());
			},
			updateTagsInInsertions(tags, replace) {
				tags.map(tag => {
					var id = $(tag).attr('id');
					if (replace) {
						if (id) {
							this.updatedTags[id] = tag;
						} else {
							this.$emit('update-tags', tags, [this.record?.oid]);
						}
					} else {
						delete this.updatedTags[id];
					}
				});
			}
		},
	}
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.audio-tracker-insertion--details {

		.ssml-icon {
			font-size: 12px !important;
		}

		.jodit_icon.jodit_icon_break_btn {
			text-overflow: clip;
			overflow: hidden;
			width: 20px;
			height: 18px;
			margin-top: 4px;
			margin-left: 6px;
		}

		.jodit_toolbar_btn {
			> a {
				color: #333 !important;
			}
		}

		.jodit_toolbar_btn.jodit_toolbar_btn-intonation {
			width: 45px;

			> a {
				margin-left: -10px;
			}
		}

		.jodit_toolbar_btn.jodit_toolbar_btn-phoneme {
			width: 45px;

			> a {
				margin-left: -10px;
			}
		}

		.jodit_toolbar_btn.jodit_toolbar_btn-reading {
			width: 45px;

			> a {
				margin-left: -10px;
			}
		}
		
		[editorValue] {
			> editor-action {
				margin: 0px 0px 0px 4px;
				color: #aaa;
				font-weight: 100;
				text-transform: uppercase;
				font-size: 10px;
				cursor: pointer;

				&:hover {
					color: $base-accent-transparent;
					font-weight: 600;
				}
			}

			&:after {
				content: '/>';
				color: #aaa;
				font-weight: 100;
				margin: 0px 2px 0px 2px;
				font-size: 10px;
			}

			&.selected {
				> editor-action {
					color: $base-accent;
					font-weight: 600;
				}

				&:after{
					color: $base-accent;
					font-weight: 600;
				}
			}
		}
	}

	.jodit-ui-group__intonationToLeft {
		.jodit-toolbar-button__icon {
			transform: rotate(45deg);
		}
	}

	.jodit-ui-group__intonationToRight {
		.jodit-toolbar-button__icon {
			transform: rotate(45deg);
		}
	}
</style>
